import React, { useContext } from 'react';
import ThrottlingCheckbox from 'integrations/components/ThrottlingCheckbox';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';

import type { HandleFieldUpdateType, FormDataContextType, AdvancedOptionsContextType } from '../common/utils/types';
import { FormDataContext } from '../common/context/FormData';
import { AdvancedOptionsContext } from '../common/context/AdvancedOptions';

interface Props {
  onChange: HandleFieldUpdateType;
}

const FormAdvancedOptions = ({ onChange }: Props) => {
  const { formData } = useContext<FormDataContextType>(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } =
    useContext<AdvancedOptionsContextType>(AdvancedOptionsContext);

  const { sophosThrottleEnabled } = formData;

  const handleToggle: (visible: boolean) => void = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  return (
    <AdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <ThrottlingCheckbox
        id="sophosThrottleEnabled"
        defaultChecked={sophosThrottleEnabled?.value}
        onChange={onChange}
      />
    </AdditionalFields>
  );
};

export default FormAdvancedOptions;
